<template>
  <div class="k-window-content k-content">
    <loading/>
    <router-view></router-view>
  </div>
</template>

<script>
import Loading from '@/components/Loading'
export default {
  name: 'WindowLayout',
  components : {
    Loading,
  },
  created: function() {},
}
</script>

<style scoped>
body{background: #fff !important}
</style>
